import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchSubCompareList, dispatchModalShow, dispatchTipStatus } from '../../../../store/search/actionCreator';
import styles from './index.module.scss';

function CompareCard() {
  const dispatch = useDispatch();

  const {
    compareList,
    modalShow,
    tipShow,
    tips,
    allData
  } = useSelector(state => state.searchReducer);
  const [emptyCompareList, setEmptyCompareList] = useState(new Array(4).fill(false));

  useEffect(() => {
    setEmptyCompareList(new Array(4 - compareList?.length).fill(false));
  }, [compareList])


  const handleDeleteCompareItem = (skuId) => {
    let _compareList = [...compareList];
    _compareList = _compareList.filter(item => item.skuId != skuId);
    setEmptyCompareList(new Array(4 - _compareList.length).fill(false));
    dispatch(dispatchSubCompareList(_compareList))
  }

  const handleDeleteAll = () => {
    if(compareList.length <= 0) return;
    setEmptyCompareList(new Array(4).fill(false));
    dispatch(dispatchSubCompareList([]))
  }

  const handleCompare = () => {
    if(compareList.length < 2){
      dispatch(dispatchTipStatus({
        tipShow: true,
        tips: '至少有两件商品才能对比哦！'
      }))

      setTimeout(() => {
        dispatch(dispatchTipStatus({
          tipShow: false,
          tips: ''
        }))
      }, 500)
    }else{
      const skus = [0, 0, 0, 0];;
      compareList.forEach((item, index) => skus[index] = item.skuId);
      const url = `http://www.jd.com/compare/${skus.join('-')}.html`;
      window.open(url);
    }
  }

  const ChangeVisibility = () => {
    dispatch(dispatchModalShow(false))
  }

  if(!modalShow || allData.skuComparePCSwitch !== 'ON') return null;

  return (
    <div data-load="false" className={styles["pop-compare-narrow"]}>
      <div className={styles["pop-wrap"]}>
        {tipShow && <p className={styles["pop-compare-tips"]}>{tips}</p>}
        <div className={styles["pop-inner"]}>
          <div className={styles["diff-hd"]}>
            <ul className={`${styles["tab-btns"]} clearfix`}>
              <li className={styles.current}>
                <span>对比栏</span>
              </li>
              {/* <li>
                <a href="javascript:;">最近浏览</a>
              </li> */}
            </ul>
            <div className={styles.operate}>
              <span className={styles["hide-me"]} onClick={ChangeVisibility}>隐藏</span>
            </div>
          </div>
          <div className={`${styles["diff-bd"]}`}>
            <div className={styles["tab-con"]} data-widget="tab-content">
              <div className={`${styles["diff-items"]} clearfix`}>
                {/* <dl className={styles["item-empty"]}>
                  <dt>1</dt>
                  <dd>您还可以继续添加</dd>
                </dl>
                <dl className={styles["item-empty"]}>
                  <dt>2</dt>
                  <dd>您还可以继续添加</dd>
                </dl>
                <dl className={styles["item-empty"]}>
                  <dt>3</dt>
                  <dd>您还可以继续添加</dd>
                </dl>
                <dl className={styles["item-empty"]}>
                  <dt>4</dt>
                  <dd>您还可以继续添加</dd>
                </dl> */}
                {
                  compareList.map(compareItem => {
                    return (
                      <dl className={styles.hasItem} id="cmp_item_2190107" key={compareItem.skuId}>
                        <dt>
                          <a target="_blank" rel="noopener noreferrer" href={`http://npcitem.jd.hk/${compareItem.skuId}.html`}>
                            <img src={`//img12.360buyimg.com/n5/${compareItem.imagePath}`} width="50" height="50" alt=''/>
                          </a>
                        </dt>
                        <dd>
                          <a target="_blank" rel="noopener noreferrer" className={styles["diff-item-name"]} href="http://npcitem.jd.hk/2190107.html">{compareItem.name}</a>
                          <span className={styles["p-price"]}>
                            {/* <strong className="J-p-2190107"></strong> */}
                            <span className={`${styles["del-comp-item"]} ${styles["selected"]}`} onClick={() => handleDeleteCompareItem(compareItem.skuId)}>删除</span>
                          </span>
                        </dd>
                      </dl>
                    )
                  })
                }
                {
                  emptyCompareList.map((item, index) => {
                    const showIndex = index + compareList?.length + 1;
                    return (
                      <dl className={styles["item-empty"]} key={showIndex}>
                        <dt>{showIndex}</dt>
                        <dd>您还可以继续添加</dd>
                      </dl>
                    )
                  })
                }
              </div>
              <div className={styles["diff-operate"]}>
                <span className={`${styles["btn-compare-b"]} ${compareList.length > 1 ? styles["compare-active"] : null}`} onClick={handleCompare}>对比</span>
                <span className={styles["del-items"]} onClick={handleDeleteAll}>清空对比栏</span>
              </div>
            </div>
            {/* <div className={styles["tab-con" style="display:none;" data-widget="tab-content">
              <div className={styles["scroll-item clearfix">
                <span id="sc-prev" className={styles["scroll-btn sb-prev">&lt;</span>
                <span id="sc-next" className={styles["scroll-btn sb-next">&gt;</span>
                <div className={styles["scroll-con clearfix">
                  <ul id="scroll-con-inner">
                    <p className={styles["scroll-loading ac">载入中...</p>
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div >
  )
}

export default CompareCard;